module.exports = __webpack_public_path__ + "img/img04.c606ee04.jpg";